import CryptoJS from "crypto-js";
// src/utils/checksum.js
export async function createChecksum(data, clientId, clientSecret) {
  // Build the string in the exact same order as Python
  const rawString = `${clientId}|${data.amount}|${data.phone_number}|${data.first_name}|${data.email}|${data.lang_code}|${data.transaction_id}|${clientSecret}`;
  // Encode to bytes
  const encoder = new TextEncoder();
  const encoded = encoder.encode(rawString);

  // Compute SHA-512 digest
  const hashBuffer = await window.crypto.subtle.digest("SHA-512", encoded);

  // Convert ArrayBuffer → hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");

  return hashHex;
}


export const AesECBEncrypt = (key, plaintext) => {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(plaintext), CryptoJS.enc.Utf8.parse(key), {
      mode: CryptoJS.mode.ECB,
    }).toString();
    return encrypted;
  };



  export const AesECBDecrypt = (key, encryptedText) => {
 
    const decrypted = CryptoJS.AES.decrypt(
      encryptedText,
      CryptoJS.enc.Utf8.parse(key),
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8).trim();
    try {
      return JSON.parse(decryptedText);
    } catch {
      return decryptedText; // not JSON
    }
  };

  export const AesECBDecryptObject = (key, enryptedText) => {
    const decrypted = CryptoJS.AES.decrypt(enryptedText, CryptoJS.enc.Utf8.parse(key), { mode: CryptoJS.mode.ECB });

    if (decrypted) {
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8).trim();
      return decryptedText;
    }

    return null;
  };

export const decryptAndUnwrap = (cipher, key) => {
  const plain = AesECBDecrypt(key, cipher);

  let payload = JSON.parse(plain);        // first parse

  if (Array.isArray(payload)) payload = payload[0];

  if (typeof payload?.result === "string") {
    payload = JSON.parse(payload.result);
  }

  return payload;
};

export function AesECBDecryptt(base64Key, encryptedBase64) {
   // Decode the Base64 key → UTF-8 WordArray
  const key = CryptoJS.enc.Utf8.parse((base64Key));

  // Decrypt AES-ECB
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    key,
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}

export function decryptAES256ECBUrlSafe(secretKey, ciphertextUrlSafe) {
  try {
    if (!ciphertextUrlSafe) return null;
    let base64 = String(ciphertextUrlSafe).replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) {
      base64 += "=".repeat(4 - pad);
    }

    const key = CryptoJS.enc.Utf8.parse(secretKey);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(base64),
      },
      key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const result = decrypted.toString(CryptoJS.enc.Utf8);
    if (!result) {
      throw new Error("Invalid key or corrupted data");
    }

    try {
      return JSON.stringify(JSON.parse(result), null, 2);
    } catch (e) {
      return result;
    }
  } catch (error) {
    console.error("Decryption failed:", error);
    throw error;
  }
}

export function isLinkExpired(linkTimestamp) {
  if (!linkTimestamp) return true;
  const currentTimestamp = Math.floor(Date.now() / 1000);
  return currentTimestamp >= parseInt(linkTimestamp, 10);
}

/**
 * Adler-32 checksum (matches Python zlib.adler32(str.encode("utf-8"))).
 * @param {string} str - UTF-8 string
 * @returns {number} signed 32-bit integer checksum
 */
export function adler32Checksum(str) {
  const MOD = 65521;
  const bytes = new TextEncoder().encode(str);
  let a = 1;
  let b = 0;
  for (let i = 0; i < bytes.length; i++) {
    a = (a + bytes[i]) % MOD;
    b = (b + a) % MOD;
  }
  const n = (b << 16) | a;
  return n >= 0x80000000 ? n - 0x100000000 : n;
}

